/**
 * GSAP Fade In Up Stagger Animation
 *
 * HOW TO USE:
 * 1. Create a wrapper element with class "fade-in-up-stagger-smooth-wrapper"
 * 2. Add child elements with class "fade-in-up-stagger-smooth-item"
 * 3. Items will animate in sequence with a staggered delay
 *
 * EXAMPLE:
 * <div class="fade-in-up-stagger-smooth-wrapper">
 *   <div class="fade-in-up-stagger-smooth-item">Item 1</div>
 *   <div class="fade-in-up-stagger-smooth-item">Item 2</div>
 *   <div class="fade-in-up-stagger-smooth-item">Item 3</div>
 * </div>
 *
 * BONUS FEATURE:
 * If stagger items contain <a> links, they get hover scale effects automatically.
 *
 * ANIMATION DETAILS:
 * - Each item starts: opacity 0, y: 20, scale: 0.8
 * - Duration: 0.5 seconds per item
 * - Stagger delay: 0.1 seconds between items
 * - Easing: back.out(1.7) (bouncy effect)
 * - Triggers when wrapper top reaches 95% of viewport height
 * - Plays once only
 * - Hover effect: links scale to 1.1 on mouseenter, back to 1 on mouseleave
 */

// GSAP animations for fade-in-up-stagger elements
const gsapFadeInUpStaggerSmoothAnimations = () => {
  const staggerWrappers = document.querySelectorAll(
    ".fade-in-up-stagger-smooth-wrapper"
  );

  if (!staggerWrappers.length) return;

  staggerWrappers.forEach((wrapper) => {
    // Animate stagger items
    const animateSmoothStaggerItems = () => {
      const staggerItems = wrapper.querySelectorAll(
        ".fade-in-up-stagger-smooth-item"
      );

      if (staggerItems.length > 0) {
        var tl = gsap.timeline({
          scrollTrigger: {
            trigger: wrapper,
            start: "top 95%",
            toggleActions: "play none none none",
          },
        });

        tl.from(staggerItems, {
          duration: 0.5,
          opacity: 0,
          y: 20,
          stagger: 0.1,
          ease: "power2.out",
        });
      }
    };

    // Initialize animations for this wrapper
    animateSmoothStaggerItems();
  });
};

// Initialize everything when DOM is ready
if (document.readyState !== "loading") {
  gsapFadeInUpStaggerSmoothAnimations();
} else {
  document.addEventListener("DOMContentLoaded", () => {
	gsapFadeInUpStaggerSmoothAnimations();
  });
}
